import {
  ReferralBonus,
  ReferralPowerUpTypeSourceMap,
} from "../../Common/models/config";

export const getRefferedBonusEntries = (
  { type, value }: ReferralBonus,
  entriesPerMonth: number
) => {
  switch (type) {
    case 1:
      return {
        title: `Bonus Power Up entries`,
        promoText: `free $${ReferralPowerUpTypeSourceMap[value].value} Power Up`,
        value: ReferralPowerUpTypeSourceMap[value].entries,
      };
    case 2:
      return {
        title: "Bonus entries",
        promoText: `additional ${value} entries`,
        value,
      };
    case 3:
      return {
        title: `Bonus ${value}x entry multiplier`,
        promoText: `${value}X entries`,
        value: entriesPerMonth * (value - 1),
      };
    default:
      return {
        title: "Bonus entries",
        value,
        promoText: `additional ${value} entries`,
      };
  }
};
